import { useAuth } from '../context/AuthContext'
import { useTranslation } from 'react-i18next'

export default function Login() {
  const { t } = useTranslation(['settings'])
  const { login } = useAuth()

  return (
    <div className="min-h-screen bg-[#f7f7f8] flex items-center justify-center px-4">
      <div className="w-full max-w-sm">
        <div className="flex flex-col items-center mb-8">
          <img src="/logo.png" alt="REM PMO" className="w-12 h-12 rounded-xl mb-3 shadow-sm" />
          <h1 className="text-xl font-bold text-gray-900 tracking-tight">REM PMO</h1>
          <p className="text-sm text-gray-400 mt-0.5">{t('login.tagline')}</p>
        </div>

        <div className="bg-white shadow-sm border border-gray-200 rounded-2xl p-8 flex flex-col items-center">
          <button
            onClick={login}
            className="w-full bg-gray-900 text-white py-2.5 rounded-lg text-sm font-medium hover:bg-gray-700 transition-colors"
          >
            {t('login.microsoft')}
          </button>
          <p className="text-xs text-gray-400 mt-3 text-center">{t('login.microsoftHint')}</p>
        </div>
      </div>
    </div>
  )
}
